/**
 * 国家Code
 */
export const COUNTRY_CODE = {
  /**
   * 印尼
   */
  ID: "ID",
  /**
   * 越南
   */
  VN: "VN",
  /**
   * 马来
   */
  MY: "MY",
  /**
   * 菲律宾
   */
  PH: "PH",
  /**
   * 德国
   */
  DE: "DE",
  /**
   * 西班牙
   */
  ES: "ES",
};

/**
 * 国家货币码
 */
export const COUNTRY_CURRENCY_CODE = {
  /**
   * 印尼
   */
  ID: "Rp",
  /**
   * 越南
   */
  VN: "₫",
  /**
   * 马来
   */
  MY: "RM",
  /**
   * 菲律宾
   */
  PH: "₱",
  /**
   * 德国
   */
  DE: "€",
  /**
   * 西班牙
   */
  ES: "€",
};
